import React, {useEffect, useState} from "react";

export default function Clock({hour = 24, clockClass = '', vertical = false}) {
    const [time, setTime] = useState();

    const addLeadingZero = (n) => {
        if (n.length < 2) return '0' + n;
        return n
    }

    const getDate = () => {
        let hours, minutes, seconds;
        let prefix = '';
        let date = new Date();
        if (hour === 24) {
            hours = addLeadingZero(date.getHours().toString())
        }

        if (hour === 12) {
            let currentHour = date.getHours()
            prefix = (currentHour / 2 > 12) ? ' am' : ' pm';
            hours = addLeadingZero((currentHour % 12).toString())
        }

        minutes = addLeadingZero(date.getMinutes().toString())
        seconds = addLeadingZero(date.getSeconds().toString())
        if (vertical) {
            return (
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <div>{hours}</div>
                    <div>{minutes}</div>
                    <div>{seconds}</div>
                </div>)
        }

        return `${hours}:${minutes}:${seconds}${prefix}`
    }

    useEffect(() => {
        setTimeout(() => {
            setTime(getDate())
        }, 1000)
    })


    return (
        <div className={clockClass}>{time}</div>
    )
}